export default __webpack_public_path__ + "static/media/ic_flag.550750a4.svg";